export { default } from "./physical";
